import React from "react";

// favorite icon svg string so we can animate the fill
const FAVORITE_PATH =
  "M17.75 5.50676C17.75 2.87967 15.6569 0.75 13.075 0.75C11.6146 0.796301 10.2348 1.4421 9.25 2.54027C8.26516 1.4421 6.88538 0.796301 5.425 0.75C2.84307 0.75 0.75 2.87967 0.75 5.50676C0.75 8.89703 4.7875 12.6419 6.7 14.5878L8.638 16.5597C8.75744 16.6814 8.91948 16.7498 9.0885 16.75H9.4115C9.58052 16.7498 9.74256 16.6814 9.862 16.5597L11.8 14.5878C13.7125 12.6419 17.75 8.89703 17.75 5.50676Z";

// Custom rendering for the favorite icon so we can animate the fill-opacity
// - using inline svgs for track icons icon for faster, non-laggy rendering (may replace with SVGR in the future)
export const ICON_RENDERERS = {
  favorite: ({ selected }) => (
    <svg
      viewBox="-1.0278 -2.5278 20.5556 20.5556"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={FAVORITE_PATH}
        fill="currentColor"
        fillOpacity={selected ? 1 : 0}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        style={{ transition: "fill-opacity 200ms ease" }}
      />
    </svg>
  ),
  menu: () => (
    <svg
      viewBox="0 0 17 14"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 2.25H1.125C0.503719 2.25 0 1.74628 0 1.125C0 0.503719 0.503719 0 1.125 0H15.75C16.3713 0 16.875 0.503719 16.875 1.125C16.875 1.74628 16.3713 2.25 15.75 2.25Z"
        fill="currentColor"
      />
      <path
        d="M15.75 13.5H1.125C0.503719 13.5 0 12.9963 0 12.375C0 11.7537 0.503719 11.25 1.125 11.25H15.75C16.3713 11.25 16.875 11.7537 16.875 12.375C16.875 12.9963 16.3713 13.5 15.75 13.5Z"
        fill="currentColor"
      />
      <path
        d="M15.75 7.875H1.125C0.503719 7.875 0 7.37128 0 6.75C0 6.12872 0.503719 5.625 1.125 5.625H15.75C16.3713 5.625 16.875 6.12872 16.875 6.75C16.875 7.37128 16.3713 7.875 15.75 7.875Z"
        fill="currentColor"
      />
    </svg>
  ),
  caret_down: () => (
    <svg
      viewBox="0 0 13 11"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.40108 10.9853L6.12145 10.9853C5.85525 10.9845 5.60892 10.8443 5.47232 10.6158L0.269268 1.67776C-0.0503054 1.13848 -0.0503054 0.858852 0.089508 0.619172L0.229321 0.369506C0.362201 0.146998 0.59943 0.00767306 0.858481 -5.10489e-07L11.664 -3.81627e-08C11.9303 0.000807595 12.1766 0.141022 12.3132 0.369506L12.453 0.619173C12.5928 0.858853 12.5928 1.13848 12.1834 1.83755L7.05021 10.6158C6.91361 10.8443 6.66728 10.9845 6.40108 10.9853Z"
        fill="currentColor"
      />
    </svg>
  ),
  similar_tracks: () => (
    <svg
      viewBox="0 0 18 18"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.04 10.8086C12.04 10.2407 11.9512 9.6936 11.7869 9.18026L9.18023 11.7869C9.69358 11.9512 10.2407 12.04 10.8086 12.04C11.1909 12.04 11.5638 11.9997 11.9233 11.9233C11.9997 11.5638 12.04 11.1909 12.04 10.8086ZM6.35268 9.64045C6.75111 10.2439 7.26881 10.7615 7.87221 11.16L11.16 7.87224C10.7615 7.26884 10.2439 6.75112 9.64045 6.35268L6.35268 9.64045ZM1.36818 10.8086C1.36818 13.7555 3.75715 16.1445 6.70408 16.1445C8.71695 16.1445 10.4694 15.0299 11.3782 13.3843C11.1904 13.4001 11.0005 13.4082 10.8086 13.4082C7.10606 13.4082 4.10454 10.4066 4.10454 6.70408C4.10454 6.51223 4.11259 6.32226 4.12839 6.13449C2.48276 7.04326 1.36818 8.79575 1.36818 10.8086ZM13.4082 10.8086C13.4082 11.0005 13.4001 11.1904 13.3843 11.3782C15.0299 10.4694 16.1445 8.71695 16.1445 6.70408C16.1445 3.75715 13.7555 1.36818 10.8086 1.36818C8.79575 1.36818 7.04326 2.48276 6.13449 4.12839C6.32226 4.11259 6.51223 4.10454 6.70408 4.10454C10.4066 4.10454 13.4082 7.10606 13.4082 10.8086ZM5.47272 6.70408C5.47272 7.27196 5.56149 7.8191 5.72581 8.33243L8.33243 5.72581C7.8191 5.56149 7.27196 5.47272 6.70408 5.47272C6.32179 5.47272 5.94891 5.51299 5.58939 5.58939C5.51299 5.94891 5.47272 6.32179 5.47272 6.70408ZM17.5127 6.70408C17.5127 9.62767 15.6413 12.1141 13.031 13.031C12.1141 15.6413 9.62767 17.5127 6.70408 17.5127C3.00152 17.5127 0 14.5112 0 10.8086C0 7.88503 1.87142 5.39854 4.48169 4.48169C5.39854 1.87142 7.88503 0 10.8086 0C14.5112 0 17.5127 3.00152 17.5127 6.70408Z"
        fill="currentColor"
      />
    </svg>
  ),
  download: () => (
    <svg
      viewBox="0 0 18 18"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.8 14C8.6 14 8.4 13.9 8.3 13.8L3.2 8.6C3 8.4 3 8.1 3.2 7.9L3.9 7.2C4 7 4.4 7 4.6 7.3L8 10.7V0.5C8 0.2 8.2 0 8.5 0H9.5C9.8 0 10 0.2 10 0.5V10.7L13.4 7.3C13.6 7.1 13.9 7.1 14.1 7.3L14.8 8C15 8.2 15 8.5 14.8 8.7L9.7 13.8C9.6 13.9 9.4 14 9.2 14H8.8ZM18 12.5V16C18 17.1 17.1 18 16 18H2C0.9 18 0 17.1 0 16V12.5C0 12.2 0.2 12 0.5 12H1.5C1.8 12 2 12.2 2 12.5V16H16V12.5C16 12.2 16.2 12 16.5 12H17.5C17.8 12 18 12.2 18 12.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  share_copy_link: () => (
    <svg
      viewBox="0 0 20 17"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9207 1.8823L3.01487 1.71626L7.40718 5.92003L14.9207 1.8823ZM8.26702 7.39625L9.80045 13.3087L15.8457 3.32079L8.26702 7.39625ZM18.1583 0.24155C18.32 0.233259 18.4809 0.269173 18.6228 0.345227C18.7646 0.42128 18.8818 0.534435 18.9609 0.671883C19.0401 0.80933 19.0781 0.96558 19.0706 1.12295C19.0632 1.28031 19.0106 1.43251 18.9188 1.5623L10.2521 15.8808C10.1726 16.0351 10.0464 16.1622 9.89043 16.2447C9.73448 16.3272 9.55628 16.3613 9.37981 16.3424C9.20333 16.3235 9.03704 16.2525 8.90331 16.1389C8.76957 16.0254 8.6748 15.8747 8.63176 15.7072L6.4775 7.39625L0.258419 1.44457C0.135352 1.32654 0.0513367 1.17546 0.0171456 1.01069C-0.0170454 0.845917 0.000146136 0.67497 0.066516 0.519765C0.132886 0.364559 0.245409 0.23217 0.389658 0.139572C0.533907 0.0469737 0.703307 -0.00161329 0.876137 4.08747e-05L18.1583 0.24155Z"
        fill="currentColor"
      />
    </svg>
  ),
  collection: () => (
    <svg
      viewBox="0 0 15 13"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.43791 0H10.355C11.172 0 11.8342 0.709597 11.8342 1.58493V11.0945C11.8342 11.9698 11.172 12.6794 10.355 12.6794H4.43791C3.62093 12.6794 2.95864 11.9698 2.95864 11.0945V1.58493C2.95864 0.709597 3.62093 0 4.43791 0ZM10.355 11.0944V1.58483H4.43796V11.0944H10.355ZM14.0524 11.0944C14.4609 11.0944 14.792 10.7396 14.792 10.3019V2.37729C14.792 1.93963 14.4609 1.58483 14.0524 1.58483H13.3128V11.0944H14.0524ZM0 2.37729C0 1.93963 0.331145 1.58483 0.739634 1.58483H1.47927V11.0944H0.739634C0.331145 11.0944 0 10.7396 0 10.3019V2.37729Z"
        fill="currentColor"
      />
    </svg>
  ),
  add_queue: () => (
    <svg
      viewBox="0 0 20 17"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.21502 14.5717H1.73354C1.17799 14.5717 0.807617 14.1669 0.807617 13.5598C0.807617 12.9526 1.17799 12.5479 1.73354 12.5479H8.21502C8.77058 12.5479 9.14095 12.9526 9.14095 13.5598C9.14095 14.1669 8.77058 14.5717 8.21502 14.5717Z"
        fill="currentColor"
      />
      <path
        d="M18.3995 13.5596H12.8439C12.2883 13.5596 11.918 13.1548 11.918 12.5477C11.918 11.9405 12.2883 11.5358 12.8439 11.5358H18.3995C18.955 11.5358 19.3254 11.9405 19.3254 12.5477C19.3254 13.1548 18.955 13.5596 18.3995 13.5596Z"
        fill="currentColor"
      />
      <path
        d="M15.6222 16.5952C15.0667 16.5952 14.6963 16.1905 14.6963 15.5833V9.5119C14.6963 8.90476 15.0667 8.5 15.6222 8.5C16.1778 8.5 16.5481 8.90476 16.5481 9.5119V15.5833C16.5481 16.1905 16.1778 16.5952 15.6222 16.5952Z"
        fill="currentColor"
      />
      <path
        d="M11.9187 9.51172H1.73354C1.17799 9.51172 0.807617 9.10696 0.807617 8.49982C0.807617 7.89268 1.17799 7.48792 1.73354 7.48792H11.9187C12.4743 7.48792 12.8447 7.89268 12.8447 8.49982C12.8447 9.10696 12.4743 9.51172 11.9187 9.51172Z"
        fill="currentColor"
      />
      <path
        d="M11.9187 4.4524H1.73354C1.17799 4.4524 0.807617 4.04764 0.807617 3.44049C0.807617 2.83335 1.17799 2.42859 1.73354 2.42859H11.9187C12.4743 2.42859 12.8447 2.83335 12.8447 3.44049C12.8447 4.04764 12.4743 4.4524 11.9187 4.4524Z"
        fill="currentColor"
      />
    </svg>
  ),
  cart: () => (
    <svg
      viewBox="0 0 18 18"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.29442 1.77121H17.2691C17.5137 1.77121 17.7119 1.96945 17.7119 2.214V2.6568C17.7055 3.39174 17.5071 4.11223 17.1363 4.74681L15.0551 8.40432C14.6048 9.21373 13.7583 9.72294 12.8323 9.74157H7.31502C7.12361 9.73745 6.93336 9.7107 6.74824 9.66186L5.86264 11.5128H15.4979C15.7425 11.5128 15.9407 11.711 15.9407 11.9556V12.8412C15.9407 13.0857 15.7425 13.284 15.4979 13.284H4.42798C4.18562 13.2896 3.95897 13.1644 3.83463 12.9563L3.6398 12.6198C3.5374 12.4227 3.5374 12.1881 3.6398 11.991L5.28701 8.71428C5.19705 8.61929 5.11694 8.51544 5.0479 8.40432L1.25755 1.77121H0.442798C0.198247 1.77121 0 1.57296 0 1.32841V0.442812C0 0.198261 0.198247 1.40206e-05 0.442798 1.40206e-05H1.25755C1.89285 -0.00250817 2.48084 0.335417 2.79848 0.88561L3.29442 1.77121ZM12.8678 7.97044C13.1469 7.93665 13.3934 7.77231 13.532 7.52764L15.622 3.87013C15.6556 3.80283 15.6822 3.73198 15.7084 3.66207L15.7084 3.66205L15.7084 3.66203L15.7084 3.66201C15.7235 3.62155 15.7386 3.58141 15.7548 3.54246H4.31292L6.5889 7.52764C6.74614 7.8 7.03603 7.96854 7.35051 7.97044H12.8678ZM14.1692 14.1695C13.191 14.1695 12.398 14.9625 12.398 15.9407C12.398 16.9189 13.191 17.7118 14.1692 17.7118C15.1474 17.7118 15.9404 16.9189 15.9404 15.9407C15.9404 14.9625 15.1474 14.1695 14.1692 14.1695ZM3.54208 15.9407C3.54208 14.9625 4.33507 14.1695 5.31327 14.1695C6.29148 14.1695 7.08447 14.9625 7.08447 15.9407C7.08447 16.9189 6.29148 17.7118 5.31327 17.7118C4.33507 17.7118 3.54208 16.9189 3.54208 15.9407Z"
        fill="currentColor"
      />
    </svg>
  ),
  info_panel: () => (
    <svg
      viewBox="0 0 20 20"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3125 20H4.6875C2.10281 20 0 17.8972 0 15.3125V4.6875C0 2.10281 2.10281 0 4.6875 0H15.3125C17.8972 0 20 2.10281 20 4.6875V15.3125C20 17.8972 17.8972 20 15.3125 20ZM4.6875 1.5625C2.96438 1.5625 1.5625 2.96438 1.5625 4.6875V15.3125C1.5625 17.0356 2.96438 18.4375 4.6875 18.4375H15.3125C17.0356 18.4375 18.4375 17.0356 18.4375 15.3125V4.6875C18.4375 2.96438 17.0356 1.5625 15.3125 1.5625H4.6875Z"
        fill="currentColor"
      />
      <path
        d="M10 15.3125C9.56852 15.3125 9.21875 14.9627 9.21875 14.5312V8.55469C9.21875 8.1232 9.56852 7.77344 10 7.77344C10.4315 7.77344 10.7812 8.1232 10.7812 8.55469V14.5312C10.7812 14.9627 10.4315 15.3125 10 15.3125ZM10 4.6875C9.46066 4.6875 9.02344 5.12473 9.02344 5.66406C9.02344 6.2034 9.46066 6.64062 10 6.64062C10.5393 6.64062 10.9766 6.2034 10.9766 5.66406C10.9766 5.12473 10.5393 4.6875 10 4.6875Z"
        fill="currentColor"
      />
    </svg>
  ),
  open_editor: () => (
    <svg
      viewBox="0 0 19 19"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.49996 4.11267C7.89531 4.11267 6.58984 5.41814 6.58984 7.02279C6.58984 8.62743 7.89531 9.9329 9.49996 9.9329C11.1046 9.9329 12.4101 8.62743 12.4101 7.02279C12.4101 5.41814 11.1046 4.11267 9.49996 4.11267ZM9.49996 8.48991C8.6909 8.48991 8.03288 7.83162 8.03288 7.02282C8.03288 6.21377 8.6909 5.55574 9.49996 5.55574C10.3088 5.55574 10.967 6.21377 10.967 7.02282C10.967 7.83188 10.3088 8.48991 9.49996 8.48991Z"
        fill="currentColor"
      />
      <path
        d="M9.49984 8.51392C9.10132 8.51392 8.77832 8.83692 8.77832 9.23543V17.7975C8.77832 18.196 9.10132 18.519 9.49984 18.519C9.89835 18.519 10.2214 18.196 10.2214 17.7975V9.23543C10.2214 8.83692 9.89835 8.51392 9.49984 8.51392Z"
        fill="currentColor"
      />
      <path
        d="M9.49984 0.480957C9.10132 0.480957 8.77832 0.803957 8.77832 1.20247V4.83411C8.77832 5.23263 9.10132 5.55563 9.49984 5.55563C9.89835 5.55563 10.2214 5.23263 10.2214 4.83411V1.20247C10.2214 0.803957 9.89835 0.480957 9.49984 0.480957Z"
        fill="currentColor"
      />
      <path
        d="M16.0898 9.06714C14.4854 9.06714 13.1797 10.3726 13.1797 11.9773C13.1797 13.5819 14.4854 14.8874 16.0898 14.8874C17.6945 14.8874 18.9999 13.5819 18.9999 11.9773C18.9999 10.3726 17.6942 9.06714 16.0898 9.06714ZM16.0898 13.4446C15.2805 13.4446 14.6225 12.7863 14.6225 11.9773C14.6225 11.1682 15.2807 10.5102 16.0898 10.5102C16.8989 10.5102 17.5569 11.1685 17.5569 11.9773C17.5569 12.7866 16.8986 13.4446 16.0898 13.4446Z"
        fill="currentColor"
      />
      <path
        d="M16.0897 13.4443C15.6912 13.4443 15.3682 13.7673 15.3682 14.1659V17.7975C15.3682 18.196 15.6912 18.519 16.0897 18.519C16.4884 18.519 16.8112 18.196 16.8112 17.7975V14.1659C16.8112 13.7673 16.4882 13.4443 16.0897 13.4443Z"
        fill="currentColor"
      />
      <path
        d="M16.0897 0.480957C15.6912 0.480957 15.3682 0.803957 15.3682 1.20247V9.7645C15.3682 10.163 15.6912 10.486 16.0897 10.486C16.4884 10.486 16.8112 10.163 16.8112 9.7645V1.20247C16.8112 0.803957 16.4882 0.480957 16.0897 0.480957Z"
        fill="currentColor"
      />
      <path
        d="M2.91012 9.06714C1.30547 9.06714 0 10.3726 0 11.9773C0 13.5819 1.30547 14.8874 2.91012 14.8874C4.51476 14.8874 5.82023 13.5819 5.82023 11.9773C5.82027 10.3726 4.5148 9.06714 2.91012 9.06714ZM2.91012 13.4446C2.10106 13.4446 1.44304 12.7863 1.44304 11.9773C1.44304 11.1682 2.10106 10.5102 2.91012 10.5102C3.71918 10.5102 4.3772 11.1685 4.3772 11.9773C4.3772 12.7866 3.71918 13.4446 2.91012 13.4446Z"
        fill="currentColor"
      />
      <path
        d="M2.90999 13.4443C2.51148 13.4443 2.18848 13.7673 2.18848 14.1659V17.7975C2.18848 18.196 2.51148 18.519 2.90999 18.519C3.30851 18.519 3.63151 18.196 3.63151 17.7975V14.1659C3.63151 13.7673 3.30851 13.4443 2.90999 13.4443Z"
        fill="currentColor"
      />
      <path
        d="M2.90999 0.480957C2.51148 0.480957 2.18848 0.803957 2.18848 1.20247V9.7645C2.18848 10.163 2.51148 10.486 2.90999 10.486C3.30851 10.486 3.63151 10.163 3.63151 9.7645V1.20247C3.63151 0.803957 3.30851 0.480957 2.90999 0.480957Z"
        fill="currentColor"
      />
    </svg>
  )
};
